import { useEffect, useState } from "react";

export default function FloatingWhatsAppButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show once user has scrolled roughly past the hero (use viewport height as proxy).
      setVisible(window.scrollY > window.innerHeight * 0.6);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <a
      href="https://wa.me/message/FCKA446LLDR5H1"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className={`fixed z-50 inline-flex flex-col items-center justify-center bg-[#1FAE63] text-white transition-all duration-300 hover:scale-105 bottom-6 right-6 w-14 h-14 rounded-xl md:rounded-full ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <i className="ri-whatsapp-fill text-2xl md:text-3xl leading-none" />
      <span className="text-[10px] font-medium leading-tight mt-0.5 md:hidden">Chat</span>
    </a>
  );
}
